module.exports = __webpack_public_path__ + "static/img/40006 (3).5361423.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40006 (3).webp
// module id = 94Xk
// module chunks = 14